import { render, staticRenderFns } from "./LinkInBioVideo.vue?vue&type=template&id=c459038e"
import script from "./LinkInBioVideo.vue?vue&type=script&lang=js"
export * from "./LinkInBioVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports